import MdsTag from './tag.vue';
import MdsTagContainer from './tag-container.vue';

export { MdsTag, MdsTagContainer };
